/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/number-utils/get-floor-at */
import { isPositiveZero } from './is-positive-zero.js';
/**
 * @description Returns the base of the number at the selected level.
 * @param {number} num - Input number.
 * @param {number} lvl - Base level.
 * @returns {(number|null)} Base.
 */

function getFloorAt(num, lvl) {
  var x = null;
  var length = num.toString().length;

  if (Math.abs(lvl) >= length) {
    return null;
  } else if (lvl > 0 || isPositiveZero(lvl)) {
    x = Math.pow(10, length - lvl - 1);
    return Math.floor(num / x) * x;
  } else {
    x = Math.pow(10, lvl * -1);
    return Math.floor(num / x) * x;
  }
}

export { getFloorAt };